import React from "react";
import { StyleTransactionCard, StyleTransactionCardWrapper } from "./style";
import { Calendar, HandCoins, ReceiptIcon } from "lucide-react";
import Typography from "@components/typography";

const TransactionCard = () => {
  return (
    <StyleTransactionCardWrapper>
      <StyleTransactionCard>
        <ReceiptIcon color="#3b82f6" />
        <Typography styleText="color:#3b82f6">Total Transaction</Typography>
        <Typography styleText="color:#3b82f6">8</Typography>
      </StyleTransactionCard>
      <StyleTransactionCard>
        <HandCoins color="#10b981" />
        <Typography styleText="color:#10b981">Total Earnings</Typography>
        <Typography styleText="color:#10b981">Rs 120394</Typography>
      </StyleTransactionCard>
      <StyleTransactionCard style={{ border: "none" }}>
        <Calendar color="#ff3135" />
        <Typography styleText="color:#ff3135">Earning This Month</Typography>
        <Typography styleText="color:#ff3135">Rs 0</Typography>
      </StyleTransactionCard>
    </StyleTransactionCardWrapper>
  );
};

export default TransactionCard;
